module.exports = __webpack_public_path__ + "static/media/location.72bf61fb.svg";